var _defs, _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdderessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: url(#linear-gradient1);\r\n      }\r\n\r\n      .st2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-dasharray: 3.6 3.6;\r\n      }\r\n\r\n      .st3 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22.8,
    y1: 40,
    x2: 53.2,
    y2: 40,
    gradientTransform: "translate(0 78) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69a4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 36.2,
    y1: 35.2,
    x2: 39.8,
    y2: 35.2,
    gradientTransform: "translate(0 78) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69a4d"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 37.8,
    cy: 37.8,
    r: 37.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.4,
    cy: 37.8,
    r: 31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.9,39.7h0c.9,0,1.7-.8,1.7-1.7v-6.7c0-.9-.8-1.7-1.7-1.7h0c-.9,0-1.7.8-1.7,1.7v6.7c0,.9.8,1.7,1.7,1.7ZM31.2,52.7l-7.9-7.9c-.3-.3-.5-.7-.5-1.2v-11.2c0-.4.2-.9.5-1.2l7.9-7.9c.3-.3.7-.5,1.2-.5h11.2c.4,0,.9.2,1.2.5l7.9,7.9c.3.3.5.7.5,1.2v11.2c0,.4-.2.9-.5,1.2l-7.9,7.9c-.3.3-.7.5-1.2.5h-11.2c-.4,0-.9-.2-1.2-.5ZM33.7,49.8h8.3c.4,0,.9-.2,1.2-.5l5.9-5.9c.3-.3.5-.7.5-1.2v-8.3c0-.4-.2-.9-.5-1.2l-5.9-5.9c-.3-.3-.7-.5-1.2-.5h-8.3c-.4,0-.9.2-1.2.5l-5.9,5.9c-.3.3-.5.7-.5,1.2v8.3c0,.4.2.9.5,1.2l5.9,5.9c.3.3.7.5,1.2.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 42.8,
    r: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdderessIcon);
export default __webpack_public_path__ + "static/media/AdderessIcon.0484f762cc23b111d0b2533818bcea8a.svg";
export { ForwardRef as ReactComponent };